import { PAGE_URLS } from '../../helpers/endpoints';

export default {
  name: 'auth',
  component: require('layouts/Auth').default,
  routes: [
    {
      path: PAGE_URLS.AUTHORIZED,
      component: require('views/Auth/LoginAuthorized').default,
    },
  ],
};
